import React, { useEffect, useState } from 'react';
import { sections } from '../data/proposal';
export function DeckNav() {
  const [active, setActive] = useState<string>(sections[0].id);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) setActive(visible.target.id);
    }, {
      rootMargin: '-40% 0px -50% 0px',
      threshold: [0, 0.25, 0.5, 1]
    });
    sections.forEach(({
      id
    }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
  return <nav aria-label="Proposal sections" className="fixed left-6 top-1/2 z-40 hidden -translate-y-1/2 xl:block" data-id="element-18" data-mp="3nckyn8zxi3ro">
      <ul className="flex flex-col gap-1.5" data-id="element-19" data-mp="16qtix6ojvss1">
        {sections.map(section => {
        const isActive = active === section.id;
        return <li key={section.id} data-id="element-20" data-mp="zge9ior99m3a">
              <a href={`#${section.id}`} aria-current={isActive ? 'true' : undefined} className="group flex items-center gap-3 rounded-full py-1 pl-1 pr-3 font-body text-xs tracking-[0.16em] text-white/35 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-21" data-mp="zh62drtgx5pv">
                <span aria-hidden="true" className={`h-px transition-all ${isActive ? 'w-8 bg-primary' : 'w-4 bg-white/25 group-hover:w-6 group-hover:bg-secondary'}`} data-id="element-22" data-mp="gs99nsdpyl9r" />
                <span className={isActive ? 'text-primary' : undefined} data-id="element-23" data-mp="ui30gg8sbfm4">{section.index}</span>
                <span className={`whitespace-nowrap uppercase transition-opacity ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} data-id="element-24" data-mp="3t8czntv1x5af">
                  {section.label}
                </span>
              </a>
            </li>;
      })}
      </ul>
    </nav>;
}